{
  "placeholder": {
    "title": "Submissions",
    "description": "Submissions are not available yet."
  }
}
